// Copyright (c) 2016 Deere & Company

import KeyValuePairCollection from '@deere/cps-it.warranty-model-factory/lib/key-value-pair-collection';
import actions from '../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const updateRetailerNames = (state, action) =>
    KeyValuePairCollection.update(state, {
        $set: action.data
    });

export default (state = getClaimDefaultState().retailerNameCollection, action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_MASS_CHANNEL_PDI_RETAILER_NAME_COLLECTION]: updateRetailerNames
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/marketing/mass-channel-pdi/reducers/retailer-name-collection.js